import { hoursToMilliseconds } from 'date-fns';

export const getDifferenceTimeInHours = (timestamp1: number, timestamp2: number) => {
  const differenceInMilliseconds = Math.abs(timestamp1 - timestamp2);
  const differenceInHours = differenceInMilliseconds / hoursToMilliseconds(1);

  return differenceInHours;
};
